/** MUI */
import {
    FormControlLabel,
    styled,
    Switch,
    Typography,
} from "@mui/material";

/** Component styles */
const StyledSwitch = styled(Switch)(({ theme }) => ({
    padding: 8,
    '& .MuiSwitch-switchBase': {
        transitionDuration: '300ms',
        '&.Mui-checked': {
            color: '#FFF',
            '& + .MuiSwitch-track': {
                backgroundColor: theme.palette.N090,
                opacity: 1,
            },
            '&.Mui-disabled + .MuiSwitch-track': {
                opacity: 0.5,
            },
        },
        '&.Mui-disabled .MuiSwitch-thumb': {
            color: "#FFF",
        },
        '&.Mui-disabled + .MuiSwitch-track': {
            backgroundColor: theme.palette.N038,
            opacity: 0.5,
        },
    },
    '& .MuiSwitch-track': {
        backgroundColor: theme.palette.N050,
        borderRadius: 22 / 2,
        opacity: 1,
        '&::before, &::after': {
            content: '""',
            height: 16,
            position: 'absolute',
            top: '50%',
            transform: 'translateY(-50%)',
            width: 16,
        },
    },
    '& .MuiSwitch-thumb': {
        boxShadow: 'none',
        height: 16,
        margin: 2,
        width: 16,
    },
}));

const BaseSwitch = ( props ) => {
    const {
        checked,
        disabled,
        id,
        key,
        label,
        labelPlacement,
        labelVariant,
        onChange,
        required,
    } = props;

    return (
        <FormControlLabel
            control={
                <StyledSwitch
                    id={`mui-custom-switch-${ id }`}
                    checked={checked}
                    disableRipple
                    onChange={onChange}
                    sx={{ mx: 0.5 }}
                />
            }
            disabled={disabled}
            key={key}
            labelPlacement={labelPlacement}
            label={
                <Typography variant={labelVariant} color="primary" noWrap>
                    {label}
                </Typography>
            }
            required={required}
        />
    )
}

export default BaseSwitch;